/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Stage_PendingInputs */

const vi_carrier_stage_pending = /** @type {(inputs: Carrier_Stage_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ tạo vận đơn`)
};

/**

* @param {Carrier_Stage_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_stage_pending = /** @type {((inputs?: Carrier_Stage_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Stage_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_stage_pending(inputs)
});